import { RewardId } from '@/enums/reward-id';
import { useUserRewardsBySeachParamReward } from '@/hooks/useUserRewardsBySearchParamReward';
import { DetailedUserReward } from '@/models/user-reward/detailed';
import { ErrorCard } from '@starsoft/common/components';
import { Nullable } from '@starsoft/common/interfaces';
import { Coin } from '@starsoft/common/models';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import { parseToBigInt } from '@starsoft/common/utils/parsers';
import Color from 'color';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import ClaimRewardModalContentRewardCards from './Cards';
import BonusClaimRewardModalContentHeader from './Header';
import styles from './styles.module.scss';
import { getCoin } from './utils/getCoin';

export default function ClaimReward() {
  const { t } = useTranslation('bonus');
  const { error, refetch, rewardId, isLoading, reward } =
    useUserRewardsBySeachParamReward('always');
  const [userReward, setUserReward] =
    useState<Nullable<DetailedUserReward>>(null);
  const coin: Coin | undefined = getCoin(userReward);

  function onFetchRewards() {
    if (!reward) {
      return;
    }

    setUserReward(reward);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onFetchRewards, [reward, isLoading]);

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <div
      className={styles.container}
      style={{
        //@ts-ignore
        '--data-claim-reward-modal-reward-color': reward?.reward?.color
          ? Color(reward?.reward?.color?.trim())
              .darken(0.5)
              .alpha(0.5)
              .toString()
          : '',
      }}
    >
      <div className={styles.container__form}>
        <BonusClaimRewardModalContentHeader
          rewardId={parseToBigInt(rewardId) as bigint}
          isLoading={isLoading}
          userReward={userReward}
          reward={userReward?.reward}
        />
        <ClaimRewardModalContentRewardCards />
        {reward?.reward?.id?.toString() !== RewardId.LevelUp.toString() && (
          <span className={styles.container__form__text}>
            {t('minimun_to_claim')}:
            <span
              className={`${styles.container__form__text} ${styles['container__form__text--primary']}`}
            >
              {WalletService.maskCurrency({
                amount: getMoneyOrAmount(reward?.reward?.minimum),
                coin: coin,
              })}
            </span>
          </span>
        )}
      </div>
    </div>
  );
}
